import { render, staticRenderFns } from "./fromGroup.vue?vue&type=template&id=ca1666fc&scoped=true&"
import script from "./fromGroup.vue?vue&type=script&lang=js&"
export * from "./fromGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1666fc",
  null
  
)

export default component.exports